import React from 'react';
import Navbar from '../components/Navbar';
import UnityHero from '../components/UnityHero';
import UnityPromotion from '../components/UnityPromotion';
import UnityIntegrationGrid from '../components/UnityIntegrationGrid';

const UnityPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar />
      <main>
        <UnityHero />
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-8 leading-tight">
              Visibility Isn't a Luxury. <br />
              <span className="text-emerald-600">It's a Business Requirement.</span>
            </h2>
            <p className="text-slate-600 text-xl max-w-3xl mx-auto mb-12 leading-relaxed">
              Event organizers lose up to 40% of potential ticket sales due to friction in the discovery process. Unity solves this by bridging the gap between your event and your audience's digital reality.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {[
                { label: "Conversion Lift", value: "28%" },
                { label: "Setup Time", value: "< 2m" },
                { label: "Platform Reach", value: "Global" }
              ].map((stat, i) => (
                <div key={i} className="bg-emerald-50 p-8 rounded-2xl border border-emerald-100">
                  <p className="text-emerald-600 text-4xl font-black mb-2">{stat.value}</p>
                  <p className="text-emerald-900/60 text-xs font-bold uppercase tracking-widest">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <UnityPromotion />
        <UnityIntegrationGrid />
      </main>
    </div>
  );
};

export default UnityPage;